import type { RequestState } from "@elastic/search-ui";

export const routingOptions = {
  readUrl: () => {
    // get the path name and search to ensure we have the path and the searchterm
    const pathname = globalThis.location.pathname;
    const search = globalThis.location.search;
    return pathname + search;
  },
  writeUrl: (url: string) => {
    globalThis.history.pushState(null, "", url);
  },
  stateToUrl: (state: RequestState) => {
    if (state.searchTerm === "") {
      return "";
    }
    return `?q=${state.searchTerm as string}`;
  },
  urlToState: (url: string) => {
    const match = url.match(/\?q=(\w+)/);
    if (!match) return { searchTerm: "" };
    return {
      searchTerm: match[1]
    };
  }
};
